import React, { useState } from "react";
import { McButton, McIcon } from "@maersk-global/mds-react-wrapper/components-core";
import "./FilterSelector.css";

const FilterSelector = ({
  filterConfig,
  visibleKeys,
  onAdd,
  onRemove,
  onClearAll,
  emptyStateText = "Select filters to search and filter the data.",
}) => {
  const [showSelector, setShowSelector] = useState(false);

  return (
    <>
      <div className="fsel-row">
        <div className="fsel-dropdown-wrapper">
          <McButton
            label={showSelector ? "Done Selecting" : "+ Select Filters"}
            appearance="secondary"
            fit="small"
            onClick={() => setShowSelector(!showSelector)}
          />
          {showSelector && (
            <div className="fsel-dropdown">
              <div className="fsel-dropdown-header">Select filters to add:</div>
              {filterConfig.map((filter) => (
                <label key={filter.key} className="fsel-checkbox-row">
                  <input
                    type="checkbox"
                    checked={visibleKeys.includes(filter.key)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onAdd(filter.key);
                      } else {
                        onRemove(filter.key);
                      }
                    }}
                    onClick={(e) => e.stopPropagation()}
                    className="fsel-checkbox"
                  />
                  <span>{filter.label}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {visibleKeys.length === 0 && (
          <span className="fsel-empty-text">{emptyStateText}</span>
        )}

        {visibleKeys.length > 0 && (
          <div className="fsel-chips-row">
            <span className="fsel-chips-label">Selected filters:</span>
            {visibleKeys.map((filterKey) => {
              const filter = filterConfig.find((f) => f.key === filterKey);
              return (
                <div key={filterKey} className="fsel-chip">
                  <span>{filter?.label || filterKey}</span>
                  <span
                    onClick={() => onRemove(filterKey)}
                    className="fsel-chip-remove-wrapper"
                    title={`Remove ${filter?.label || filterKey} filter`}
                  >
                    <McIcon icon="times" size="16" className="filter-tag-close-icon" />
                  </span>
                </div>
              );
            })}
            {onClearAll && visibleKeys.length > 1 && (
              <button className="fsel-clear-all" onClick={onClearAll}>
                Clear All
              </button>
            )}
          </div>
        )}
      </div>

      {showSelector && (
        <div className="fsel-overlay" onClick={() => setShowSelector(false)} />
      )}
    </>
  );
};

export default FilterSelector;
